import { useSession } from "../../../SessionContext";
import { useLanguage } from "../../../../context/LanguageContext";
import { ScreenSequence } from "../Sequences";
import { CrossoverScreen1Config } from "./DefaultOptionScreen1";
import { CrossoverScreen2Config } from "./DefaultOptionScreen2";
import { CrossoverScreen3Config } from "./DefaultOptionScreen3";
import { CrossoverScreen4Config } from "./DefaultOptionScreen4";
import { ResultScreenCrossoverCookies } from "./ResultScreenCrossoverCookies";
import { ResultScreenCrossoverCompensation } from "./ResultScreenCrossoverCompensation";
import { ResultScreenCrossoverDefault } from "./ResultScreenGlobal";
import { DefaultNudgeExplanationScreen } from "./ExplanationScreen";
import { WellDoneScreen } from "../../../WellDoneScreen";
import { DefaultOption } from "../../../../translations/experiments/Default";

export const CrossoverDefaultKey = "CrossoverDefault";

/**
 * Hook to get the Crossover Default experiment sequence with translations
 * Uses the language context to provide translated content for title/description
 */
export function useCrossoverDefaultSequence(): ScreenSequence {
    const { userData } = useSession();
    const { language } = useLanguage();
    const translations = DefaultOption[language] || DefaultOption.de;
    const randomizer1 = userData?.randomizer1 || "Bedingung 1";

    return {
        name: translations.title,
        description: translations.description,
        group: "A3",
        screens: [
            randomizer1 === "Bedingung 2"
                ? { component: CrossoverScreen2Config.component }
                : { component: CrossoverScreen1Config.component },
            randomizer1 === "Bedingung 2"
                ? { component: CrossoverScreen4Config.component }
                : { component: CrossoverScreen3Config.component },
            { component: ResultScreenCrossoverCookies.component },           // First crossover result
            { component: ResultScreenCrossoverCompensation.component },      // Second crossover result
            { component: ResultScreenCrossoverDefault.component },           // Global/class result screen
            { component: DefaultNudgeExplanationScreen.component },
            {
                component: WellDoneScreen,
                canContinueDefault: false,
            }
        ],
        resultScreenIndex: 2, // global/class result index (0-based)
        explanationScreenIndex: 5,
    };
}